
<p-dialog
header="Editar Órgão Julgador Local"
[(visible)]="display"
modal="true"
draggable="false"
[style]="{width: '94vw'}"
closeOnEscape="true">

<p-card>
  <app-orgao-julgador-local-frm (onSalvar)="onSalvarProxy()"></app-orgao-julgador-local-frm>

  <div class="form-action p-grid p-fluid">
    <div class="p-col-12 p-lg-6">
      <button pButton (click)="salvar()" class="p-button-success" label="Salvar"></button>
    </div>

    <div class="p-col-12 p-lg-6">
      <button pButton (click)="voltar()" class="p-button-secondary" label="Voltar"></button>
    </div>
  </div>
</p-card>

</p-dialog>
